import React from 'react'

import Hidden from '@material-ui/core/Hidden'

import AccountInfo from 'components/AccountInfo'

import ToolbarDesktop from './components/ToolbarDesktop'
import ToolbarMobile from './components/ToolbarMobile'
import { UserInfoResponse } from 'protos'

type AccountInfoProps = React.ComponentProps<typeof AccountInfo>

interface MainNavigationBarProps {
  accountInfo?: AccountInfoProps
  counters?: UserInfoResponse.ICounters | null
}

const MainNavigationBar: React.SFC<MainNavigationBarProps> = ({ accountInfo, counters }) => (
  <>
    <Hidden xsDown>
      <ToolbarDesktop accountInfo={accountInfo} counters={counters} />
    </Hidden>
    <Hidden smUp>
      <ToolbarMobile accountInfo={accountInfo} />
    </Hidden>
  </>
)

export default MainNavigationBar
